module.exports = __webpack_public_path__ + "img/Umb30_uv_logosleeve_5460-01.11bdb0a8.svg";